<template>
    <div class="award-item h-100">
        <div class="award-logo bg-white">
            <v-img :src="src" class="w-100"></v-img>
        </div>
        <div class="award-detail pa-20 pa-md-30 pt-70 pt-md-80 pt-lg-110 pb-lg-40 bg-white text-center helvetica">
            <h5 class="tit-txt font-weight-bold line-height-1 mb-2 mb-lg-4" data-aos="fade-down">{{year}}</h5>
            <p class="page-text--sm mb-8 mb-lg-16" data-aos="fade-up">{{tit}}</p>
            <p class="font-size-12 font-size-lg-16 color-point line-height-1">{{sc}}</p>
        </div>
    </div>
</template>

<script>

export default{
    props : {
        src : {type :String, default : ""},
        year : {type :String, default : ""},
        tit : {type :String, default : ""},
        sc : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
.award-logo{
    overflow: hidden;
    width: 110px;
    height: 110px;
    box-shadow: 0 0 15px rgba(12, 24, 49, 0.05);
    border-radius: 50%;
    margin: 0 auto -55px;
    position: relative;
}

.award-detail{
    height: calc(100% - 55px);
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .award-logo{
        width: 150px;
        height: 150px;
        box-shadow: 0 0 20px rgba(12, 24, 49, 0.05);
        margin: 0 auto -75px;
    }
    .award-detail{
        height: calc(100% - 75px);
    }
}
@media (min-width:1200px){
}

</style>